/**
 * Ficmoon 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Ficmoon 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#FC542F',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#AF6C5C',
  tagInactiveText: '#FFFFFF',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F4F1FF 0%, #FC542F 95%)',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
